<template>
  <div class="container" role="alert">
    <h1 class="header-md">Link is not valid or has expired</h1>
    <p class="pt-2">
      <slot>This link is either invalid, or the content is no longer shared by its owner.</slot>
    </p>
    <p class="pt-2"><a :href="toolkitHomeUrl" class="text-blue-500" title="Return to Goalbook Toolkit homepage">Goalbook Toolkit</a></p>
  </div>
</template>

<script setup lang="ts">
import { keepingBetaOptIn } from '@/util/beta_opt_in'

const toolkitHomeUrl = keepingBetaOptIn(`${import.meta.env.VITE_TOOLKIT_URL}/v`)
</script>
